import { Autosuggest } from '@myap/ui-library'
import fetchSchoolsByDICode from '../../requests/fetchSchoolsByDICode'

function SearchForDI({ setDICodeSelection, fieldName, suggestionIdPrefix }) {
  const [selectedText, setSelectedText] = useState('')
  const NOT_FOUND = 'not found'

  return (
    <form className="cb-blue2-bg cb-border-radius-8 cb-padding-8">
      <Autosuggest
        name={fieldName}
        label={<strong className="cb-white-color">Select Score Send Location</strong>}
        placeholder="Start typing to choose your score report recipient"
        suggestionIdPrefix={suggestionIdPrefix}
        resizeSuggestionsListener
        shadowRoot
        value={selectedText}
        onChange={e => {
          setSelectedText(e.target.value)
        }}
        fetchSuggestions={fetchSchoolsByDICode}
        renderSuggestion={({ name, city, state, country, dicode }) => (
          <div>
            <div>
              {name} ({dicode})
            </div>
            <div>
              {city ? `${city},` : ''} {state || country}
            </div>
          </div>
        )}
        selectSuggestion={val => {
          // Can't find school option is selected
          if (val === NOT_FOUND) {
            setDICodeSelection({})
            setSelectedText("I can't find the school I want to send my scores to")
            window.open('https://apscore.collegeboard.org/scores/contact-us')
          } else {
            // Else, a school was selected
            let selectedName = ''
            if (val && val.name && val.dicode) selectedName = `${val.name} (${val.dicode})`
            else if (val && val.name) selectedName = val.name
            else if (val) selectedName = val
            else selectedName = ''
            setSelectedText(selectedName)
            setDICodeSelection({ diCode: val.dicode, org: val })
          }
        }}
        footer={{
          component: props => (
            <button
              type="button"
              style={{ color: '#0077c8', textDecoration: 'underline' }}
              {...props}
            >
              Can&#39;t find your college? Contact customer service so we can help send your scores.{' '}
              <span className="sr-only">(Opens in a new window)</span>
            </button>
          ),
          value: NOT_FOUND,
        }}
      />
    </form>
  )
}

export default SearchForDI
